import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/programs/$programId/organizations/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/app/programs/${params.programId}` })
  },
})
